// extracted by mini-css-extract-plugin
export var chevron = "_2u-2";
export var chevronCollapsed = "_2u-3";
export var collapsibleHeader = "_2u-1";
export var container = "_2u-0";